import axios from "axios";
import { t } from "i18next";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/v1`,
  withCredentials: true,
});

api.interceptors.response.use((response) => response,
  (error) => {
    const { response } = error;
    // Session 만료 및 권한 부족
    if (response?.status === 401 || response?.status === 403) {
      localStorage.clear();
      return window.location.href = `${window.location.origin}/`
    }
    // 중복 로그인
    if (response?.status === 409) {
      localStorage.clear();
      window.dispatchEvent(new CustomEvent('app:alert', {
        detail: {
          title: t('accessUser.logout'),
          message: t('accessUser.duplicate_login'),
          Func: () => { window.location.href = `${window.location.origin}/` },
        },
      }));
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
